
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import Navbar4 from '../../Components/Navbar4';
import './Reviewer.css';
import { API_BASE_URL } from '../../config';

export default function Reviewer3() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const app_ID = query.get('app_ID'); // Get app_ID from query parameters
  const [application, setApplication] = useState(null);
  const [overallMarks, setOverallMarks] = useState('');
  const [evaluationReport, setEvaluationReport] = useState(null);
  const navigate = useNavigate(); // Initialize useNavigate hook

  useEffect(() => {
    const fetchApplicationDetails = async () => {
      if (app_ID) {
        try {
          const response = await axios.get(`${API_BASE_URL}/Reviewer.php?app_ID=${app_ID}`);
          setApplication(response.data);
        } catch (error) {
          console.error('Error fetching application details:', error);
          setApplication({ error: "Failed to fetch application details." });
        }
      } else {
        setApplication({ error: "No app_ID provided." });
      }
    };

    fetchApplicationDetails();
  }, [app_ID]);

  const handleFileUpload = (e) => {
    setEvaluationReport(e.target.files[0]);
  };

  const handleMarksSubmit = async () => {
    if (!overallMarks || !evaluationReport) {
      alert("Please enter the overall marks and upload the evaluation report.");
      return;
    }
  
    const formData = new FormData();
    formData.append('app_ID', app_ID);
    formData.append('overallMarks', overallMarks);
    formData.append('evaluationReport', evaluationReport);
  
    try {
      const response = await axios.post(`${API_BASE_URL}/Reviewer3Evaluvation.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.status === "success") {
        navigate('/popup2'); // Navigate to /popup on success
        // Clear the fields after successful submission
        setOverallMarks('');
        setEvaluationReport(null);
        document.getElementById('uploadReport').value = ''; // Clear the file input field
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      console.error('Error submitting marks and report:', error);
      alert("There was an error submitting the data.");
    }
  };
  

  const handleDownload = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Reviewer3Evaluvation.php`, {
        responseType: "blob", // Ensure the response is treated as a file
      });

      // Extract the file name from Content-Disposition header
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1].replace(/"/g, "")
        : "EvaluationCriteria.pdf";

      // Create a temporary URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file:", error);
      alert("Failed to download the file. Please try again later.");
    }
  };

  if (!application) {
    return <div>Loading...</div>;
  }

  if (application.error) {
    return <div>{application.error}</div>;
  }
  const handleClick = (app_ID) => {
    navigate(`/moredetailsc/${app_ID}`); // Correctly use template literal
  };

  const handleViewClick = async (app_ID) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
        responseType: 'blob', // Expect binary data (PDF file)
      });
  
      // Create a Blob object and generate a download link
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
      link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
      link.click();
  
      // Cleanup
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };
  


  return (
    <div>
      <Navbar4 />
      <h1 className="reviewer_title">Reviewer 3</h1>
      <h1 className="dpage-title">Application ID: {`${application.app_ID}_${new Date().getFullYear()}`}</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Application Id</th>
            <th>Project Title</th>
            <th>Applicant Name</th>
            <th>Application</th>
            <th>Application Details </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{`${application.app_ID}_${new Date().getFullYear()}`}</td>
            <td>{application.projectTitle}</td>
            <td>{application.name}</td>
            <td>
              <button className="view-button" onClick={() => handleViewClick(application.app_ID)}>
                View
              </button>
            </td>
            <td>
                <button 
                  className="moreDetails-button" // Add your custom class name for styling
                  onClick={() => handleClick(application.app_ID)} // Navigate to More Details
                >
                 More Details
                </button>
              </td>
          </tr>
        </tbody>
      </Table>

      <div className="download-section">
        <div className="criteria-section">
          <label htmlFor="downloadCriteria">Download Evaluation Criteria: </label>
          <button className="download-button" onClick={handleDownload}>
            Download
          </button>
          <p>(First, download the Evaluation Criteria and upload the PDF of  Evaluation Report.)</p>
        </div>

        <div className="evaluation-section">
          <div className="upload-section">
            <label htmlFor="uploadReport">Upload Evaluation Report: </label>
            <input
              type="file"
              id="uploadReport"
              onChange={handleFileUpload}
            />
          </div>

          <div className="marks-section">
            <label htmlFor="overallMarks">Overall Marks: </label>
            <input
              type="text"
              id="overallMarks"
              value={overallMarks}
              onChange={(e) => setOverallMarks(e.target.value)}
              placeholder="Enter marks"
              className="marks-input"
            />
            <button className="submit-button" onClick={handleMarksSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
